/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type Topbar_getTenants_QueryVariables = {};
export type Topbar_getTenants_QueryResponse = {
    readonly tenants: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
    }>;
};
export type Topbar_getTenants_Query = {
    readonly response: Topbar_getTenants_QueryResponse;
    readonly variables: Topbar_getTenants_QueryVariables;
};



/*
query Topbar_getTenants_Query {
  tenants {
    id
    name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Tenant",
    "kind": "LinkedField",
    "name": "tenants",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Topbar_getTenants_Query",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Topbar_getTenants_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3b727d4824ca3531c7c6fa2bb3c1d9cb",
    "id": null,
    "metadata": {},
    "name": "Topbar_getTenants_Query",
    "operationKind": "query",
    "text": "query Topbar_getTenants_Query {\n  tenants {\n    id\n    name\n  }\n}\n"
  }
};
})();
(node as any).hash = '76e5863eb547fd8a6d9f471aae76ad04';
export default node;
